import { CheqLoader, useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { useUserStore } from 'Stores/userStoreModuleFed'

import { lazyImport } from 'Utils/lazyImport'

const { DomainPresentationRoutes } = lazyImport(
  () => import('../features/DomainPresentation/routes'),
  'DomainPresentationRoutes'
)
const { PlatformsRoutes } = lazyImport(
  () => import('../features/Platforms/routes'),
  'PlatformsRoutes'
)
const { DetectionSettingsRoutes } = lazyImport(
  () => import('../features/DetectionSettings/routes'),
  'DetectionSettingsRoutes'
)

const App = () => {
  const { isLoggedIn, email } = useUserStore()
  const { setConfig } = useFrontEndEventTrackingService()

  if (!isLoggedIn) return <Navigate to="/auth" />
  else setConfig({ shouldSendEvents: !email?.includes('@combotag.com') })

  return (
    <Suspense fallback={<CheqLoader />}>
      <Outlet />
    </Suspense>
  )
}

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    errorElement: <Navigate to="/" />,
    children: [
      {
        path: '/domain/*',
        element: <DomainPresentationRoutes />,
      },
      {
        path: '/platforms/*',
        element: <PlatformsRoutes />,
      },
      {
        path: '/detection-settings/*',
        element: <DetectionSettingsRoutes />,
      },
      { path: '*', element: <Navigate to="/platforms" /> },
    ],
  },
]

export default protectedRoutes[0].children
